// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/manual.css
// module id = 1024
// module chunks = 2